export default __webpack_public_path__ + "static/media/012-placeholders.772c5d3f.png";